<script setup lang="ts">
import { usePersonalAccountDataState } from './utilities/account/useAccountDataPersonal'
import NotificationContainer from './components/notification/NotificationContainer.vue'
import AccountPersonalNavigation from './components/account/personal/AccountPersonalNavigation.vue'
import AccountPersonalPanel from './components/account/personal/AccountPersonalPanel.vue'
import LoadingSpinner from './components/base/LoadingSpinner.vue'
import { usePersonalAccountFormState } from './utilities/account/useAccountFormPersonal'
import { navigateToNextPageWithMissingFieldsForInvestmentPersonal } from './utilities/account/useAccountNavigationPersonal'
import { ref, watchEffect } from 'vue'
import { useWalletState } from './utilities/account/useWallet'
import { usePortfolio } from './utilities/portfolio/usePortfolio'
import AlertDialog from './components/dialogs/AlertDialog.vue'

const state = usePersonalAccountDataState()
const walletState = useWalletState()
const urlParams = new URLSearchParams(window.location.search)
const action = urlParams.get('action')

const {
    getOrdersPerIssuerAccepted,
    getOpenInvestments,
    getOrdersPerIssuerActiveItems,
    getOrdersPerIssuerCompletedItems,
} = usePortfolio()

watchEffect(async () => {
    await walletState.fetchWalletData()
    await state.fetchAccountData()

    if (state.accountId && window.condaUseV2FrontendPortfolioDashboard) {
        getOrdersPerIssuerAccepted(state.accountId)
        getOpenInvestments(state.accountId)
        getOrdersPerIssuerActiveItems(state.accountId)
        getOrdersPerIssuerCompletedItems(state.accountId)
    }

    if (action === 'missingDataProcessForVerification') {
        const accountFormState = usePersonalAccountFormState()
        accountFormState.missingDataProcessForVerificationActive = true
        navigateToNextPageWithMissingFieldsForInvestmentPersonal()
    }
})

const panel = ref<HTMLElement | null>(null)

function scrollIntoView() {
    if (window.innerWidth < 1024) {
        panel.value.scrollIntoView({ behavior: 'smooth' })
    }
}
</script>

<template>
    <div class="bg-gray-50">
        <NotificationContainer />
        <AlertDialog />
        <div
            v-if="state.loaded && !walletState.loading"
            class="space-x-0 space-y-6 pb-12 pt-8 lg:flex lg:space-x-7 lg:space-y-0">
            <nav class="w-full lg:w-1/4">
                <AccountPersonalNavigation @navigate="scrollIntoView" />
            </nav>
            <main ref="panel" class="w-full !pt-0 lg:w-3/4">
                <AccountPersonalPanel />
            </main>
        </div>
        <div v-else class="flex h-[65vh] items-center justify-center">
            <LoadingSpinner class="h-10 w-10 fill-primary" />
        </div>
    </div>
</template>

<style scoped></style>
